module.exports = __webpack_public_path__ + "front/img/m_1.f3657897.jpg";